import {
  NEWLINE,
  RECONTRACT,
  RRP_EQUIPMENT,
  RRP_ACCESSORY,
  RESERVE_NUMBER,
  TERMINATE_NUMBER,
  CEASE_ADDONS,
  REPLACE_SIM,
  BUY_ADD_ONS,
  CHECK_ELIGIBILITY,
  ACTIVATE_SIM,
  REPORT_LOST,
  NUMBER_PORT,
  USER_GUIDE
} from '@/config/common';

export const META_DATA_CONFIG = {
  login: {
    title: 'TITLE_LOGIN'
  },
  home: {
    title: 'TITLE_HOME'
  },
  profile: {
    title: 'TITLE_ACCOUNT_PROFILE'
  },
  brnaccount: {
    title: 'TITLE_ACCOUNT_BRNCESACCOUNT'
  },
  [NEWLINE]: {
    priceplan: {
      title: 'TITLE_NEWLINE_PRICEPLAN'
    },
    equipment: {
      title: 'TITLE_NEWLINE_EQUIPMENT'
    },
    addons: {
      title: 'TITLE_NEWLINE_ADDON'
    },
    revieworder: {
      title: 'TITLE_NEWLINE_REVIEWORDER'
    },
    checkout: {
      title: 'TITLE_NEWLINE_CHECKOUT'
    }
  },
  contract: {
    title: 'TITLE_RECONTRACT'
  },
  catalogue: {
    title: 'TITLE_CATALOGUE'
  },
  [RECONTRACT]: {
    priceplan: {
      title: 'TITLE_RECONTRACT_PRICEPLAN'
    },
    equipment: {
      title: 'TITLE_RECONTRACT_EQUIPMENT'
    },
    addons: {
      title: 'TITLE_RECONTRACT_ADDON'
    },
    revieworder: {
      title: 'TITLE_RECONTRACT_REVIEWORDER'
    },
    checkout: {
      title: 'TITLE_RECONTRACT_CHECKOUT'
    }
  },
  [RRP_EQUIPMENT]: {
    equipment: {
      title: 'TITLE_RRP_EQUIPMENT_EQUIPMENT'
    },
    revieworder: {
      title: 'TITLE_RRP_EQUIPMENT_REVIEWORDER'
    }
  },
  [RRP_ACCESSORY]: {
    equipment: {
      title: 'TITLE_RRP_ACCESSORIES_EQUIPMENT'
    },
    revieworder: {
      title: 'TITLE_RRP_ACCESSORIES_REVIEWORDER'
    }
  },
  [BUY_ADD_ONS]: {
    contract: {
      title: 'TITLE_RECONTRACT'
    },
    addons: {
      title: 'TITLE_RECONTRACT_ADDON'
    },
    revieworder: {
      title: 'TITLE_NEWLINE_REVIEWORDER'
    }
  },
  [CEASE_ADDONS]: {
    title: 'TITLE_CEASE_ADDONS'
  },
  [ACTIVATE_SIM]: {
    title: 'TITLE_ACTIVATE_SIM'
  },
  [CHECK_ELIGIBILITY]: {
    title: 'TITLE_CHECK_ELIGIBILITY'
  },
  [RESERVE_NUMBER]: {
    title: 'TITLE_RESERVE_NUMBER'
  },
  [TERMINATE_NUMBER]: {
    equipment: {
      title: 'TITLE_TERMINATE_NUMBER'
    },
    revieworder: {
      title: 'TITLE_TERMINATE_NUMBER_REVIEWORDER'
    }
  },
  [NUMBER_PORT]: {
    particulars: {
      title: 'TITLE_NUMBERPORT_PARTICULARS'
    },
    priceplan: {
      title: 'TITLE_NUMBERPORT_PRICEPLAN'
    },
    equipment: {
      title: 'TITLE_NUMBERPORT_EQUIPMENT'
    },
    addons: {
      title: 'TITLE_NUMBERPORT_ADDON'
    },
    revieworder: {
      title: 'TITLE_NUMBERPORT_REVIEWORDER'
    },
    checkout: {
      title: 'TITLE_NUMBERPORT_CHECKOUT'
    }
  },

  [REPLACE_SIM]: {
    equipment: {
      title: 'TITLE_TERMINATE_NUMBER'
    },
    revieworder: {
      title: 'TITLE_REPLACE_SIM_REVIEWORDER'
    }
  },
  [REPORT_LOST]: {
    title: 'TITLE_REPORT_LOST'
  },
  [USER_GUIDE]: {
    title: 'TITLE_USER_GUIDE'
  },
};
